import React from 'react';

import { Link } from 'react-resource-router';

import Anchor from '@atlaskit/primitives/anchor';
import Text from '@atlaskit/primitives/text';

import { useActions } from '../controllers/iph-store';

import { type IPHAnchorProps, type IPHLinkProps } from './types';

const IPHLink = ({ id, children, requiresDot, onClick, ...restProps }: IPHLinkProps) => {
	const { handleClick } = useActions();

	return (
		<>
			<Link
				onClick={(event) => {
					event.preventDefault();
					onClick?.(event);
					handleClick(id);
				}}
				{...restProps}
			>
				{children}
			</Link>
			{requiresDot && <Text>.</Text>}
		</>
	);
};

const IPHAnchor = ({ id, children, requiresDot, onClick, ...restProps }: IPHAnchorProps) => {
	const { handleClick } = useActions();

	return (
		<>
			<Anchor
				href=""
				onClick={(event, analytics) => {
					event.preventDefault();
					onClick?.(event, analytics);
					handleClick(id);
				}}
				{...restProps}
			>
				{children}
			</Anchor>
			{requiresDot && <Text>.</Text>}
		</>
	);
};

export { IPHLink, IPHAnchor };
